import React, { useEffect, useState } from 'react';
import bgImage from '../assets/bg.png'; 
import bgImage1 from '../assets/bg1.png';
import bgImage2 from '../assets/bg2.png';
import Footer from './Footer';
import serv1 from '../assets/serv1.jpg';
import serv2 from '../assets/serv2.jpg';
import serv3 from '../assets/serv3.jpg';

const images = [bgImage, bgImage1, bgImage2]; 

export default function Home() {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [nextImageIndex, setNextImageIndex] = useState(1);
    const [slideDirection, setSlideDirection] = useState('left');

    useEffect(() => {
        const interval = setInterval(() => {
            setSlideDirection('left'); 
            setTimeout(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
                setNextImageIndex((prevIndex) => (prevIndex + 1) % images.length);
            }, 1000); 
        }, 10000); 

        return () => clearInterval(interval); 
    }, []);
    return (
        <div>
       <div className="relative isolate h-screen flex flex-col justify-center items-center overflow-hidden">
                <div className="absolute inset-0 flex transition-transform duration-1000 ease-in-out">
                    <div
                        className={`absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-in-out zoom-out`}
                        style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
                    />
                    <div
                        className={`absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-in-out ${slideDirection === 'left' ? '-translate-x-full' : 'translate-x-0'}`}
                        style={{ backgroundImage: `url(${images[nextImageIndex]})` }}
                    />
                </div>

                <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56 text-center relative z-10 md:ml-[15%]">
                    <h1 className="text-4xl font-maiandra tracking-tight text-gray-200 sm:text-6xl">
                       Occupational Health & Safety Conference 
                        <span className="bg-[#D69A31] text-2xl text-white rounded-md ml-4 p-2">
                            2024
                        </span>
                    </h1>
                    <p className="mt-6 font-myraid text-lg leading-8 text-gray-300">
                        <span>Enhancing Workplace Safety and Health: Bridging Gaps in Rwanda's Safety Practices</span><br />
                        <span className="block mt-2"> <span className="font-semibold">25th October 2024</span></span>
                        <span className="block">Place: <span className="font-semibold">Rwanda, Kigali, M Hotel Kiyovu</span></span>
                    </p>
                    <div className="mt-10 flex items-center justify-center gap-x-6">
                        <a
                            href="/conference"
                            className="rounded-md bg-[#D69A31] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-green-700"
                        >
                            Read more
                        </a>
             
                    </div>
               
                </div>
            </div>



    <div className="bg-white">
      <div className="mx-auto max-w-7xl py-24 sm:px-6 sm:py-32 lg:px-8">
        <div className="relative isolate overflow-hidden  px-6 pt-16 sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0">
          <svg
            viewBox="0 0 1024 1024"
            aria-hidden="true"
            className="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0"
          >
            <defs>
              <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641">
                <stop stopColor="#7775D6" />
                <stop offset={1} stopColor="#E935C1" />
              </radialGradient>
            </defs>
          </svg>
          <div className="mx-auto max-w-auto text-center lg:mx-0 lg:flex-auto lg:py-32 lg:text-left">
            <h2 className="text-3xl font-maiandra tracking-tight text-black sm:text-4xl">
              About Ohs Works.
              <br />
            </h2>
            <p className="mt-6 text-lg font-myraid leading-10 text-gray-500">
            OHS Works Co Ltd is a leading provider of comprehensive occupational health and safety (OHS) solutions in Rwanda, committed to ensuring safer and healthier workplace and environments for businesses and institutions across multiple sectors.
            With a firm commitment to promoting health and safety across all industries, we specialize in four key areas: the supply of high-quality safety gear, organizing influential conferences, and offering strategic advisory services. Our vision is to become Rwanda's premier provider of occupational health and safety (OHS) solutions, and we are driven by international best practices to foster safe, efficient, and compliant work environments.            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6 lg:justify-start">
              <a
                href="/about"
                className="rounded-md bg-[#D69A31] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
              >
                Lear more
              </a>
              
            </div>
            <h2 className="text-3xl text-center my-8 font-maiandra tracking-tight text-black sm:text-4xl">
            We operate across four key business pillars:              <br />
            </h2>
          </div>
        
        </div>
        <div className="mx-auto max-w-auto p-2 mx-2 ">
         
        <div className="mt-0 grid grid-cols-1  lg:grid-cols-4 gap-8">
              
             

              <div style={{ backgroundImage: `url(${serv3})` }}  className="bg-[#f5f5f5] p-6 rounded-lg shadow-md mx-8 md:mx-1">
                <h4 className="text-2xl md:text-4xl  font-maiandra text-white">OHS Consulting</h4>
                <p className="mt-4 text-white">
                Strategic OHS Consulting Services
            </p>
              </div>         
              <div style={{ backgroundImage: `url(${serv2})`,   backgroundSize: '500% 500%' }}  className="bg-[#f5f5f5] p-6 rounded-lg shadow-md mx-8 md:mx-1">
                <h4 className="text-2xl md:text-4xl   font-maiandra text-white">OHS Conferences</h4>
                <p className="mt-4 text-white">
                Promoting a Culture of Workplace Safety                </p>
              </div> 
              <div style={{ backgroundImage: `url(${serv3})`, backgroundSize: '800% 800%' }}  className="bg-[#f5f5f5] p-6 rounded-lg shadow-md mx-8 md:mx-1">
                <h4 className="text-2xl md:text-4xl   font-maiandra text-white"> OHS Supplies</h4>
                <p className="mt-4 text-white">
                Occupational Safety Gear & Equipment                </p>
              </div> 
              <div style={{ backgroundImage: `url(${serv1})`,  backgroundSize: '130% 130%',  backgroundPosition: 'right',  }}  className="bg-[#f5f5f5] p-6 mx-8 md:mx-1 rounded-lg shadow-md">
                <h4 className="text-2xl md:text-4xl font-maiandra text-white">OHS Education</h4>
                <p className="mt-4 text-white">
                Workplace Safety Training & Certification Programs                </p>
              </div> 
        </div>
      </div>
      </div>
    </div>


    {/* service section */}

 
        <Footer />
        </div>
    );
}
